export class HrOrgCardsKey {
    private static readonly keyPrefix = 'hrOrgCards';
    public static title = `${HrOrgCardsKey.keyPrefix}.title`;
    public static pageHeader = `${HrOrgCardsKey.keyPrefix}.pageHeader`;
    public static header = `${HrOrgCardsKey.keyPrefix}.header`;
    public static generalInfoPageHeader = `${HrOrgCardsKey.keyPrefix}.generalInfoPageHeader`;
    public static responsibilityPageHeader = `${HrOrgCardsKey.keyPrefix}.responsibilityPageHeader`;
    public static subunitsPageHeader = `${HrOrgCardsKey.keyPrefix}.subunitsPageHeader`;
    public static employeesPageHeader = `${HrOrgCardsKey.keyPrefix}.employeesPageHeader`;
    public static staticInfoPageHeader = `${HrOrgCardsKey.keyPrefix}.staticInfoPageHeader`;
    public static movementDefinitionPageHeader = `${HrOrgCardsKey.keyPrefix}.movementDefinitionPageHeader`;
    public static search = `${HrOrgCardsKey.keyPrefix}.search`;
    public static taskRelation = `${HrOrgCardsKey.keyPrefix}.taskRelation`;
}
